import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Features() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="px-6 md:px-10 max-w-[1280px] mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block text-xs font-medium text-primary-500 bg-primary-50 border border-primary-200/60 px-4 py-1.5 rounded-full mb-5">
            平台特色
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
            为什么选择炮渣漫画
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-[560px] mx-auto">
            海量韩漫资源，高清画质，极速加载，为您带来最优质的阅读体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {[
            { icon: 'ri-stack-line', title: '海量漫画库', desc: '收录5000+部精选韩国漫画，涵盖恋爱、热血、奇幻等多种类型' },
            { icon: 'ri-flashlight-line', title: '极速更新', desc: '与韩国同步更新，最新章节第一时间翻译上线，追漫不等待' },
            { icon: 'ri-shield-check-line', title: '无删减版本', desc: '坚持提供无删减原版内容，完整呈现作者创作意图与故事精髓' },
            { icon: 'ri-smartphone-line', title: '多端畅读', desc: '支持电脑、平板、手机多设备阅读，随时随地享受漫画乐趣' },
          ].map((feature, index) => (
            <div
              key={index}
              className="group bg-background-50 hover:bg-primary-500 border border-background-200/70 hover:border-primary-500 rounded-xl p-6 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-background-100 group-hover:bg-white/20 rounded-lg mb-5 transition-colors">
                <i className={`${feature.icon} text-xl text-primary-500 group-hover:text-white transition-colors`}></i>
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-900 group-hover:text-white mb-3 transition-colors">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 group-hover:text-white/80 leading-relaxed transition-colors">
                {feature.desc}
              </p>
              <div className="mt-5 flex items-center gap-1 text-primary-500 group-hover:text-white text-sm font-medium transition-colors">
                <span>了解更多</span>
                <i className="ri-arrow-right-line text-xs"></i>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-14 grid grid-cols-2 sm:grid-cols-4 gap-8 text-center">
          {[
            { num: '5000+', label: '漫画资源' },
            { num: '300万+', label: '月活读者' },
            { num: '99.7%', label: '好评率' },
            { num: '7×24h', label: '更新保障' },
          ].map((stat, index) => (
            <div key={index}>
              <p className="font-heading text-2xl md:text-3xl font-bold text-primary-500">{stat.num}</p>
              <p className="text-sm text-foreground-500 mt-1">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}